import { render, staticRenderFns } from "./UketsukeOrderMain.vue?vue&type=template&id=c9120e84&"
import script from "./UketsukeOrderMain.vue?vue&type=script&lang=ts&"
export * from "./UketsukeOrderMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports